import React from 'react';
import PropTypes from 'prop-types';

const Context = React.createContext({});

export const ServerVarsContextConsumer = Context.Consumer;

export function ServerVarsContextProvider({
    children,
    isDesktop,
    isMobile,
    isSbAdsEnabled,
    isTablet,
    clientConf,
    localeOrigin,
}) {
    return (
        <Context.Provider
            value={{
                isDesktop,
                isMobile,
                isSbAdsEnabled,
                isTablet,
                clientConf,
                localeOrigin,
            }}
        >
            {children}
        </Context.Provider>
    );
}

ServerVarsContextProvider.defaultProps = {
    clientConf: {},
};

ServerVarsContextProvider.propTypes = {
    children: PropTypes.node,
    isDesktop: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isSbAdsEnabled: PropTypes.bool,
    isTablet: PropTypes.bool.isRequired,
    clientConf: PropTypes.object.isRequired,
    localeOrigin: PropTypes.string,
};
